import { createApp } from 'vue'
import { createHead } from '@vueuse/head'

import App from './App.vue'
import router from './router'
import store from './store'
import Image from '@/components/image/Image'
import { dragscrollNext } from "vue-dragscroll";


const app = createApp(App)
const head = createHead()

app.config.globalProperties.$IMG = (path)=> {
  return `https://deep.ogqgyn.com/${path}`
}

// app.config.globalProperties.$API_URL = process.env.NODE_ENV !== 'development' ? '//demo_api.gynetworks.com:22200' : '//3.39.28.139:22200'
app.config.globalProperties.$API_URL = '//demo_api.gynetworks.com:22200/v2'
app.config.globalProperties.$API_OPTIONS = {
  headers: {
    Authorization: 'Basic b2dxOmd5bg=='
  },
  timeout: 60 * 1000
}
app.config.globalProperties.$notify = (message='', options={})=> {
  store.dispatch('pushItem', {message, options})
}

window.popStateDetected = false
window.addEventListener('popstate', () => {
  window.popStateDetected = true
})

app.directive('dragscroll', dragscrollNext);

app
  .component('Image', Image)
  .use(store)
  .use(head)
  .use(router)
  .mount('#app')
